import {
  CUSTOMER_LOG_NAVIGATION_V822,
  resolvePortalNavigationV811,
} from './portalNavigationV811';

export const ACUVERSE_NAV_GROUPS_V9 = [
  'workspace',
  'api',
  'customers',
  'usage',
  'support',
];

export const buildAcuverseNavigationV9 = ({ user, hierarchy, chatEnabled }) => {
  if (user?.account_kind_v110 === 'staff') {
    return [
      { name: 'staff_workbench_v110', to: '/staff', icon: 'briefcase', group: 'workspace' },
      { name: 'staff_security_v110', to: '/staff/security', icon: 'shield alternate', group: 'support' },
    ];
  }
  if (!user || !hierarchy.ready) return [];
  const root = user.role >= 100;
  const admin = user.role >= 10;
  const buttons = [
    { name: 'header.home', to: '/home', icon: 'home', group: 'workspace' },
    { name: 'v9.workbench', to: '/', icon: 'grid layout', group: 'workspace' },
    {
      name: 'header.dashboard',
      to: '/dashboard',
      icon: 'chart bar outline',
      group: 'workspace',
    },
    { name: 'header.model', to: '/model', icon: 'cubes', group: 'api' },
    { name: 'coding_apps_v115', to: '/coding-apps', icon: 'terminal', group: 'api', root: true },
    {
      name: 'header.routing',
      to: '/routing',
      icon: 'random',
      group: 'api',
      root: true,
    },
    {
      name: 'header.basePrices',
      to: '/base-prices',
      icon: 'calculator',
      group: 'api',
      root: true,
    },
    {
      name: 'header.sourceMultipliers',
      to: '/source-multipliers',
      icon: 'sliders horizontal',
      group: 'api',
      root: true,
    },
    {
      name: 'header.channel',
      to: '/channel',
      icon: 'sitemap',
      group: 'api',
      admin: true,
    },
    {
      name: 'header.token',
      to: hierarchy.child ? hierarchy.to : '/token',
      icon: 'key',
      group: 'api',
    },
    ...(!hierarchy.child
      ? [
          {
            name: 'header.organization',
            to: hierarchy.to,
            icon: 'building outline',
            group: 'customers',
          },
        ]
      : []),
    {
      name: 'header.user',
      to: '/user',
      icon: 'users',
      group: 'customers',
      admin: true,
    },
    {
      name: 'staff_admin_v110',
      to: '/staff',
      icon: 'id badge outline',
      group: 'customers',
      root: true,
    },
    {
      name: 'v9.redemptions',
      to: '/redemption',
      icon: 'ticket',
      group: 'customers',
      admin: true,
    },
    {
      name: 'header.billing',
      to: '/billing',
      icon: 'file alternate outline',
      group: 'usage',
    },
    ...CUSTOMER_LOG_NAVIGATION_V822.map((item) => ({
      ...item,
      group: 'usage',
    })),
    {
      name: 'header.documentation',
      to: '/docs',
      icon: 'book',
      group: 'support',
    },
    ...(chatEnabled
      ? [
          {
            name: 'header.chat',
            to: '/chat',
            icon: 'comments outline',
            group: 'support',
          },
        ]
      : []),
    { name: 'v9.about', to: '/about', icon: 'info circle', group: 'support' },
  ];
  return resolvePortalNavigationV811(
    buttons,
    hierarchy.portalProfile,
    root
  ).filter((item) => (!item.admin || admin) && (!item.root || root));
};

export const matchAcuverseNavigationV9 = (items, pathname) =>
  [...items]
    .sort((first, second) => second.to.length - first.to.length)
    .find(
      (item) =>
        pathname === item.to ||
        (item.to !== '/' && pathname.startsWith(item.to + '/'))
    ) ||
  (pathname === '/setting' || pathname.startsWith('/setting/')
    ? { name: 'header.setting', to: '/setting' }
    : undefined);
